export default "__VITE_ASSET__ySTUNuhn__"